<template>
  <div class="relative flex items-center">
    <VuePopper
      ref="popper"
      trigger="clickToOpen"
      class="flex items-center"
      :options="{
        placement,
        flipVariations: false
      }"
    >
      <!-- Dropdown -->
      <div
        ref="dropdown"
        style="z-index: 100000; max-height: 360px;"
        class="mt-2 popper overflow-hidden "
        :class="whiteBackgroud ? 'dropdown-white' : 'dropdown-card'"
        @mouseleave="isMouseInside = false"
        @mouseenter="isMouseInside = true"
      >
        <div
          v-if="items.length"
          class="flex"
        >
          <div
            class="gap-y-px py-3 border-r border-border-normal overflow-y-auto h-max"
            style="max-height: 360px;"
          >
            <div
              v-for="(item, index) in items"
              :key="index"
              class="hover:bg-neutral-25 hover:bg-opacity-40 rounded-md mx-3 my-1"
              :class="index === selectedTab ? 'bg-neutral-25 bg-opacity-40' : ''"
            >
              <div
                v-if="item.subItems?.length"
                class="px-1"
              >
                <div
                  class="cursor-pointer transition duration-300 flex justify-between rounded-md"
                >
                  <div
                    class="flex items-center justify-center w-44 h-max group"
                    @click="handleSelectMainItem(index)"
                  >
                    <div class="h-5 w-5 object-cover">
                      <svg
                        v-if="item.icon === 'brand profile'"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M3.95841 16.875V4.79167C3.95841 3.87119 4.70461 3.125 5.62508 3.125H14.3751C15.2956 3.125 16.0417 3.87119 16.0417 4.79167V16.875M3.95841 16.875H16.0417M3.95841 16.875H2.29175M16.0417 16.875H17.7084M7.29175 6.45833H8.54175M11.4584 6.45833H12.7084M7.29175 9.79167H8.54175M11.4584 9.79167H12.7084M7.29175 13.125H8.54175M11.4584 13.125H12.7084"
                          stroke="#5E6678"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      <svg
                        v-else-if="item.icon === 'board'"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M4.03502 16.6933L4.37551 16.0251H4.37551L4.03502 16.6933ZM3.30666 15.965L3.97491 15.6245H3.97491L3.30666 15.965ZM16.6933 15.965L16.0251 15.6245L16.0251 15.6245L16.6933 15.965ZM15.965 16.6933L15.6245 16.0251L15.6245 16.0251L15.965 16.6933ZM16.6933 4.03502L16.0251 4.37551L16.0251 4.37551L16.6933 4.03502ZM15.965 3.30666L15.6245 3.97491L15.6245 3.97491L15.965 3.30666ZM3.30666 4.03502L2.6384 3.69452L2.6384 3.69452L3.30666 4.03502ZM4.03502 3.30666L3.69452 2.6384L3.69452 2.6384L4.03502 3.30666ZM10.75 3.125V2.375H9.25V3.125H10.75ZM3.125 7.375H2.375V8.875H3.125V7.375ZM9.25 16.875V17.625H10.75V16.875H9.25ZM16.875 12.625H17.625V11.125H16.875V12.625ZM16.125 5.79167V14.2083H17.625V5.79167H16.125ZM14.2083 16.125H5.79167V17.625H14.2083V16.125ZM3.875 14.2083V5.79167H2.375V14.2083H3.875ZM5.79167 3.875H14.2083V2.375H5.79167V3.875ZM5.79167 16.125C5.31258 16.125 4.99837 16.1244 4.75808 16.1048C4.52654 16.0859 4.43042 16.0531 4.37551 16.0251L3.69452 17.3616C3.99613 17.5153 4.31163 17.5733 4.63593 17.5998C4.95147 17.6256 5.33733 17.625 5.79167 17.625V16.125ZM2.375 14.2083C2.375 14.6627 2.37442 15.0485 2.4002 15.3641C2.42669 15.6884 2.48472 16.0039 2.6384 16.3055L3.97491 15.6245C3.94693 15.5696 3.91413 15.4735 3.89522 15.2419C3.87558 15.0016 3.875 14.6874 3.875 14.2083H2.375ZM4.37551 16.0251C4.20303 15.9372 4.0628 15.797 3.97491 15.6245L2.6384 16.3055C2.87009 16.7602 3.2398 17.1299 3.69452 17.3616L4.37551 16.0251ZM16.125 14.2083C16.125 14.6874 16.1244 15.0016 16.1048 15.2419C16.0859 15.4735 16.0531 15.5696 16.0251 15.6245L17.3616 16.3055C17.5153 16.0039 17.5733 15.6884 17.5998 15.3641C17.6256 15.0485 17.625 14.6627 17.625 14.2083H16.125ZM14.2083 17.625C14.6627 17.625 15.0485 17.6256 15.3641 17.5998C15.6884 17.5733 16.0039 17.5153 16.3055 17.3616L15.6245 16.0251C15.5696 16.0531 15.4735 16.0859 15.2419 16.1048C15.0016 16.1244 14.6874 16.125 14.2083 16.125V17.625ZM16.0251 15.6245C15.9372 15.797 15.797 15.9372 15.6245 16.0251L16.3055 17.3616C16.7602 17.1299 17.1299 16.7602 17.3616 16.3055L16.0251 15.6245ZM17.625 5.79167C17.625 5.33733 17.6256 4.95147 17.5998 4.63593C17.5733 4.31163 17.5153 3.99613 17.3616 3.69452L16.0251 4.37551C16.0531 4.43042 16.0859 4.52654 16.1048 4.75808C16.1244 4.99837 16.125 5.31258 16.125 5.79167H17.625ZM14.2083 3.875C14.6874 3.875 15.0016 3.87558 15.2419 3.89522C15.4735 3.91413 15.5696 3.94693 15.6245 3.97491L16.3055 2.6384C16.0039 2.48472 15.6884 2.42669 15.3641 2.4002C15.0485 2.37442 14.6627 2.375 14.2083 2.375V3.875ZM17.3616 3.69452C17.1299 3.2398 16.7602 2.87009 16.3055 2.6384L15.6245 3.97491C15.797 4.0628 15.9372 4.20303 16.0251 4.37551L17.3616 3.69452ZM3.875 5.79167C3.875 5.31258 3.87558 4.99837 3.89522 4.75808C3.91413 4.52654 3.94693 4.43042 3.97491 4.37551L2.6384 3.69452C2.48472 3.99613 2.42669 4.31163 2.4002 4.63593C2.37442 4.95147 2.375 5.33733 2.375 5.79167H3.875ZM5.79167 2.375C5.33733 2.375 4.95147 2.37442 4.63593 2.4002C4.31163 2.42669 3.99613 2.48472 3.69452 2.6384L4.37551 3.97491C4.43042 3.94693 4.52654 3.91413 4.75808 3.89522C4.99837 3.87558 5.31258 3.875 5.79167 3.875V2.375ZM3.97491 4.37551C4.06279 4.20303 4.20303 4.06279 4.37551 3.97491L3.69452 2.6384C3.2398 2.87009 2.87009 3.2398 2.6384 3.69452L3.97491 4.37551ZM9.25 3.125V8.125H10.75V3.125H9.25ZM10 7.375H3.125V8.875H10V7.375ZM9.25 8.125V11.875H10.75V8.125H9.25ZM9.25 11.875V16.875H10.75V11.875H9.25ZM10 12.625H16.875V11.125H10V12.625Z"
                          fill="#5E6678"
                        />
                      </svg>
                      <svg
                        v-else-if="item.icon === 'folder'"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16.875 8.95833V7.29167C16.875 6.37119 16.1288 5.625 15.2083 5.625H10.4459C10.1673 5.625 9.90713 5.48575 9.75257 5.25392L8.82807 3.86717C8.51896 3.4035 7.99858 3.125 7.44132 3.125H3.95829C3.03782 3.125 2.29163 3.87119 2.29163 4.79167V14.7308C2.29163 15.4548 2.87851 16.0417 3.60247 16.0417M16.875 8.95833H7.91369C7.17434 8.95833 6.52337 9.44542 6.31475 10.1547L4.86005 15.1007C4.69597 15.6586 4.18397 16.0417 3.60247 16.0417M16.875 8.95833H17.2196C17.7759 8.95833 18.176 9.49307 18.019 10.0268L16.6018 14.8453C16.3932 15.5546 15.7422 16.0417 15.0029 16.0417H3.60247"
                          stroke="#5E6678"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      <svg
                        v-if="item.icon === 'niche'"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_7888_61360)">
                          <path
                            d="M9.99998 1.45831V6.87498M18.5416 9.99998H13.125M9.99998 13.125V18.5416M6.87498 9.99998H1.45831M9.99998 16.0416C6.66326 16.0416 3.95831 13.3367 3.95831 9.99998C3.95831 6.66326 6.66326 3.95831 9.99998 3.95831C13.3367 3.95831 16.0416 6.66326 16.0416 9.99998C16.0416 13.3367 13.3367 16.0416 9.99998 16.0416Z"
                            stroke="#5E6678"
                            stroke-width="1.25"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_7888_61360">
                            <rect
                              width="20"
                              height="20"
                              fill="white"
                            />
                          </clipPath>
                        </defs>

                      </svg>

                      <svg
                        v-if="item.icon === 'time range'"
                        width="19"
                        height="19"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 7.75L12 12L14.75 14.75M21.25 12C21.25 17.1086 17.1086 21.25 12 21.25C6.89137 21.25 2.75 17.1086 2.75 12C2.75 6.89137 6.89137 2.75 12 2.75C17.1086 2.75 21.25 6.89137 21.25 12Z"
                          stroke="#5E6678"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>

                      <svg
                        v-else-if="item.icon === 'due date'"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M3.125 8.12533H16.875M6.45833 3.95866V2.29199M13.5417 3.95866V2.29199M4.79167 16.8753H15.2083C16.1288 16.8753 16.875 16.1291 16.875 15.2087V5.62533C16.875 4.70485 16.1288 3.95866 15.2083 3.95866H4.79167C3.87119 3.95866 3.125 4.70485 3.125 5.62533V15.2087C3.125 16.1291 3.87119 16.8753 4.79167 16.8753Z"
                          stroke="#5E6678"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      <svg
                        v-else-if="item.icon === 'status'"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10.0002 2.29199L9.99996 5.20866M10.0002 14.792V17.7087M2.29163 10.0009H5.20829M14.7916 10.0009H17.7083M4.54952 4.54953L6.61174 6.61211M13.3884 13.3884L15.4508 15.4508M4.54976 15.4514L6.61215 13.389M13.3886 6.61252L15.451 4.55012"
                          stroke="#5E6678"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>

                      <svg
                        v-else-if="item.icon === 'tag'"
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <g id="tag">
                          <path
                            id="Icon"
                            d="M16.6592 9.47812L15.8647 5.15224C15.7612 4.58899 15.3205 4.14826 14.7572 4.0448L10.4313 3.25025C9.98531 3.16833 9.5275 3.31088 9.20684 3.63155L3.62323 9.21516C3.08457 9.75381 3.08457 10.6271 3.62323 11.1658L8.74366 16.2862C9.28231 16.8249 10.1556 16.8249 10.6943 16.2862L16.2779 10.7026C16.5986 10.382 16.7411 9.92415 16.6592 9.47812Z"
                            stroke="#5E6678"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            id="Icon_2"
                            d="M12.0834 7.25C11.7152 7.25 11.4167 7.54848 11.4167 7.91667C11.4167 8.28486 11.7152 8.58333 12.0834 8.58333C12.4516 8.58333 12.7501 8.28486 12.7501 7.91667C12.7501 7.54848 12.4516 7.25 12.0834 7.25Z"
                            fill="#5E6678"
                            stroke="#5E6678"
                            stroke-width="0.5"
                          />
                        </g>
                      </svg>
                      <svg
                        v-else-if="item.icon === 'format'"
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <g id="multi media, media, image and video">
                          <g id="Icon">
                            <path
                              d="M5.20841 6.24996C5.78371 6.24996 6.25008 5.78359 6.25008 5.20829C6.25008 4.633 5.78371 4.16663 5.20841 4.16663C4.63312 4.16663 4.16675 4.633 4.16675 5.20829C4.16675 5.78359 4.63312 6.24996 5.20841 6.24996Z"
                              fill="#5E6678"
                            />
                            <path
                              d="M10.8334 10.7839V14.2164C10.8334 14.7221 11.4026 15.0184 11.8168 14.7285L14.2686 13.0122C14.6241 12.7634 14.6241 12.237 14.2686 11.9882L11.8168 10.2719C11.4026 9.98194 10.8334 10.2783 10.8334 10.7839Z"
                              fill="#5E6678"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M1.66675 3.95829C1.66675 2.69264 2.69276 1.66663 3.95841 1.66663H11.0417C12.3074 1.66663 13.3334 2.69264 13.3334 3.95829V6.66663H16.0417C17.3074 6.66663 18.3334 7.69264 18.3334 8.95829V16.0416C18.3334 17.3073 17.3074 18.3333 16.0417 18.3333H8.95842C7.69276 18.3333 6.66675 17.3073 6.66675 16.0416V13.3333H3.95841C2.69276 13.3333 1.66675 12.3073 1.66675 11.0416V3.95829ZM12.0834 3.95829V6.66663H8.95842C7.77893 6.66663 6.80757 7.55768 6.68077 8.70336L6.26965 8.42928C5.49988 7.9161 4.49704 7.9161 3.72727 8.42928L2.91675 8.96963V3.95829C2.91675 3.383 3.38312 2.91663 3.95841 2.91663H11.0417C11.617 2.91663 12.0834 3.383 12.0834 3.95829ZM5.57627 9.46934L6.66675 10.1963V12.0833H3.95841C3.38312 12.0833 2.91675 11.6169 2.91675 11.0416V10.4719L4.42065 9.46934C4.77054 9.23608 5.22638 9.23608 5.57627 9.46934ZM7.91675 16.0416V8.95829C7.91675 8.383 8.38312 7.91663 8.95842 7.91663H16.0417C16.617 7.91663 17.0834 8.383 17.0834 8.95829V16.0416C17.0834 16.6169 16.617 17.0833 16.0417 17.0833H8.95842C8.38312 17.0833 7.91675 16.6169 7.91675 16.0416Z"
                              fill="#5E6678"
                            />
                          </g>
                        </g>
                      </svg>
                      <svg
                        v-else-if="item.icon === 'platform'"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M3.26184 13.2621L3.79217 12.7318L3.79217 12.7318L3.26184 13.2621ZM6.73815 16.7384L6.20782 17.2687H6.20782L6.73815 16.7384ZM16.7381 6.73839L17.2685 6.20806L17.2685 6.20806L16.7381 6.73839ZM13.2618 3.26208L13.7922 2.73175L13.7922 2.73175L13.2618 3.26208ZM10.9048 3.26208L10.3745 2.73175V2.73175L10.9048 3.26208ZM8.428 4.67824C8.1351 4.97113 8.1351 5.44601 8.428 5.7389C8.72089 6.03179 9.19576 6.03179 9.48866 5.7389L8.428 4.67824ZM5.73866 9.4889C6.03155 9.19601 6.03155 8.72113 5.73866 8.42824C5.44576 8.13535 4.97089 8.13535 4.678 8.42824L5.73866 9.4889ZM3.26184 10.9051L2.73151 10.3747L2.73151 10.3747L3.26184 10.9051ZM14.2613 10.5116C13.9684 10.8045 13.9684 11.2793 14.2613 11.5722C14.5542 11.8651 15.0291 11.8651 15.322 11.5722L14.2613 10.5116ZM16.7381 9.09542L17.2685 9.62575L17.2685 9.62575L16.7381 9.09542ZM9.09517 16.7384L9.6255 17.2687L9.09517 16.7384ZM11.572 15.3222C11.8649 15.0293 11.8649 14.5545 11.572 14.2616C11.2791 13.9687 10.8042 13.9687 10.5113 14.2616L11.572 15.3222ZM6.96966 11.9699C6.67677 12.2628 6.67677 12.7377 6.96966 13.0306C7.26256 13.3235 7.73743 13.3235 8.03032 13.0306L6.96966 11.9699ZM13.0303 8.03057C13.3232 7.73767 13.3232 7.2628 13.0303 6.96991C12.7374 6.67701 12.2626 6.67701 11.9697 6.96991L13.0303 8.03057ZM2.73151 13.7924L6.20782 17.2687L7.26848 16.2081L3.79217 12.7318L2.73151 13.7924ZM17.2685 6.20806L13.7922 2.73175L12.7315 3.79241L16.2078 7.26872L17.2685 6.20806ZM10.3745 2.73175L8.428 4.67824L9.48866 5.7389L11.4351 3.79241L10.3745 2.73175ZM4.678 8.42824L2.73151 10.3747L3.79217 11.4354L5.73866 9.4889L4.678 8.42824ZM15.322 11.5722L17.2685 9.62575L16.2078 8.56509L14.2613 10.5116L15.322 11.5722ZM9.6255 17.2687L11.572 15.3222L10.5113 14.2616L8.56484 16.2081L9.6255 17.2687ZM16.2078 7.26872C16.5658 7.6267 16.5658 8.2071 16.2078 8.56509L17.2685 9.62575C18.2122 8.68198 18.2122 7.15183 17.2685 6.20806L16.2078 7.26872ZM6.20782 17.2687C7.15159 18.2125 8.68173 18.2125 9.6255 17.2687L8.56484 16.2081C8.20686 16.566 7.62646 16.566 7.26848 16.2081L6.20782 17.2687ZM3.79217 12.7318C3.43419 12.3738 3.43419 11.7934 3.79217 11.4354L2.73151 10.3747C1.78774 11.3185 1.78774 12.8486 2.73151 13.7924L3.79217 12.7318ZM13.7922 2.73175C12.8484 1.78798 11.3183 1.78799 10.3745 2.73175L11.4351 3.79241C11.7931 3.43443 12.3735 3.43443 12.7315 3.79241L13.7922 2.73175ZM8.03032 13.0306L13.0303 8.03057L11.9697 6.96991L6.96966 11.9699L8.03032 13.0306Z"
                          fill="#5E6678"
                        />
                      </svg>

                      <svg
                        v-else-if="item.icon === 'language'"
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <g id="world, globus, internet, web">
                          <path
                            id="Icon"
                            d="M16.482 3.51816L3.51839 16.4818M17.7084 9.99996C17.7084 14.2572 14.2573 17.7083 10.0001 17.7083C5.74289 17.7083 2.29175 14.2572 2.29175 9.99996C2.29175 5.74276 5.74289 2.29163 10.0001 2.29163C14.2573 2.29163 17.7084 5.74276 17.7084 9.99996ZM15.4303 15.43C14.4307 16.4296 11.1892 14.8089 8.1903 11.81C5.19138 8.81104 3.57064 5.56956 4.57028 4.56992C5.56992 3.57028 8.8114 5.19102 11.8103 8.18994C14.8093 11.1889 16.43 14.4303 15.4303 15.43Z"
                            stroke="#5E6678"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </g>
                      </svg>
                    </div>
                    <slot
                      name="item"
                      :item="item"
                    />
                    <div
                      class="flex items-center h-5 w05 object-cover"
                    >
                      <svg
                        class="text-text-subdued ml-auto transform rotate-90 transition ease-in duration-200 opacity-0 group-hover:opacity-100 "
                        :class="{
                          'opacity-100': index === selectedTab,
                        }"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.66675 11.6669L9.41083 8.92279C9.73626 8.59735 10.2639 8.59735 10.5893 8.92279L13.3334 11.6669"
                          stroke="currentColor"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="p-3 w-80 object-contain overflow-hidden flex flex-col"
            :style="{height: items[selectedTab].item === 'Tag' ? '348px' : hasSubItems === 8 ? '394px' : '256px'}"
          >
            <BaseInputV2
              v-if="items[selectedTab].noSearch !== true"
              v-model="currentSearch"
              icon
              :placeholder="`Search for ${items[selectedTab].item.toLowerCase()}s...`"
              class="w-full"
            >
              <img
                slot="icon"
                src="../../assets/icons/search.svg"
                class="h-5 w-5"
              >
            </BaseInputV2>
            <div
              v-if="items[selectedTab].noSearch !== true"
              class="flex justify-between px-1 border-b border-border-normal "
            >
              <BaseText
                type="body"
                size="sm"
                class="py-2 text-text-subdued"
              >
                Show from
              </BaseText>
              <!-- <BaseText
                v-if="!items[selectedTab]?.subItems?.every(item => checkedItems.includes(item.id))"
                type="body"
                size="sm"
                class="cursor-pointer select-none"
                :class="`ml-2 py-2 text-primary-${getTheme}-100`"
                @click.native="selectAll"
              >
                Select all
              </BaseText>
              <BaseText
                v-if="items[selectedTab]?.subItems?.every(item => checkedItems.includes(item.id))"
                type="body"
                size="sm"
                class="cursor-pointer"
                :class="`ml-2 py-2 text-primary-${getTheme}-100`"
                @click.native="deselectAll"
              >
                Deselect all
              </BaseText> -->
            </div>
            <div
              class="overflow-y-auto -mb-2"
              :style="hasSubItems ? 'height: 16rem;' : ''"
            >
              <div
                v-for="(subItem, iteration) in items[selectedTab].subItems"
                :key="iteration"
              >
                <div
                  v-if="currentSearch === '' || containsSearch(subItem, currentSearch)"
                  class="px-1"
                >
                  <div
                    class="cursor-pointer transition duration-300 px-2 flex rounded-md items-center"
                    :class="{
                      'bg-neutral-25 my-1': subItem.hover && checkedItems.includes(subItem.id),
                      'hover:bg-neutral-25 my-1': subItem.hover && !checkedItems.includes(subItem.id),
                    }"
                    @click="subItem.id && handleChecked(subItem.id)"
                  >
                    <div
                      class="flex items-center justify-center h-max "
                    >
                      <input
                        v-if="items[selectedTab].noCheckboxes !== true"
                        type="checkbox"
                        :disabled="checkedItems.length > 0"
                        class="h-4 w-4 rounded border-border-normal focus:ring-0 cursor-pointer"
                        :class="`text-primary-${getTheme}-100`"
                        :checked="subItem.id && checkedItems.includes(subItem.id)"
                      >
                      <slot
                        name="subItem"
                        :item="subItem"
                      />
                    </div>
                    <img
                      v-if="subItem.hover"
                      src="../../assets/images/../../assets/icons/circle-checkmark-confirm.svg"
                      class="h-5 w-5 ml-auto opacity-0 transition duration-300"
                      :class="{
                        'opacity-100': subItem.hover && checkedItems.includes(subItem.id),
                      }"
                    >
                  </div>
                </div>
              </div>
              <div
                v-if="items[selectedTab]?.alertMessage"
                class="flex absolute bottom-0 items-center bg-neutral-25 px-2 mb-5 w-max pr-24 gap-1"
              >
                <img
                  src="../../assets/images/alternate-facebook-icon.svg"
                  class="h-5 w-5"
                >
                <BaseText
                  type="body"
                  size="sm"
                  class="px-1 py-2 text-text-normal text-center"
                >
                  {{ items[selectedTab]?.alertMessage }}
                </BaseText>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Reference to click and trigger the popper -->
      <div
        slot="reference"
        class="flex items-center"
      >
        <div
          v-click-outside="() => { handleOutsideClick() }"
          class="cursor-pointer ml-4 select-none hover:bg-neutral-25 transition-all duration-200 rounded-md mr-2"
          :class="{
            'bg-neutral-25 ring-2 ring-offset-2 ring-border-normal': popperOpen
          }"
        >
          <div
            class="rounded-md hover:bg-neutral-25 hover:bg-opacity-5 transition-all w-max h-max"
            @click="toggleDrawer"
          >
            <slot
              name="reference"
            />
          </div>
        </div>
      </div>
    </VuePopper>
    <div
      class="flex items-center h-5 w-max order-2"
    >
      <BaseText
        v-if="(checkedItems.length + additionalFilters) === 0"
        type="body"
        size="sm"
        class="text-text-subdued border-l border-border-normal pl-2 select-none"
      >
        No filters applied
      </BaseText>
      <div
        v-if="(checkedItems.length + additionalFilters) > 0"
        class="flex items-center"
      >
        <BaseText
          type="body"
          size="sm"
          class="text-text-subdued border-l transition-all duration-200"
          :class="`border-border-normal pl-2 text-primary-${getTheme}-100`"
        >
          {{ (checkedItems.length + additionalFilters) }} filters applied
        </BaseText>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import VuePopper from 'vue-popperjs'
import 'vue-popperjs/dist/vue-popper.css'
import ClickOutside from 'vue-click-outside'

export default {
  name: 'BaseSplitSelect',
  directives: {
    ClickOutside
  },
  components: {
    VuePopper
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    selected: {
      type: Array,
      default: () => []
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    multiple: {
      type: Boolean
    },
    noPadding: {
      type: Boolean,
      default: false
    },
    closeDropdown: {
      type: Boolean
    },
    placement: {
      type: String,
      default: 'top-start'
    },
    filter: {
      type: Boolean,
      default: false
    },
    briefs: {
      type: Array,
      default: () => []
    },
    filtered: {
      type: Array,
      default: () => []
    },
    clearAll: {
      type: Boolean,
      default: false
    },
    whiteBackgroud: {
      type: Boolean,
      default: false
    },
    emitFunction: {
      type: Function,
      default: () => {}
    },
    externalFilters: {
      type: Array,
      default: () => []
    },
    additionalFilters: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      selectedTab: 0,
      currentSearch: '',
      checkedItems: [],
      selectedAll: [],
      popperOpen: false,
      isMouseInside: false,
      appliedFilters: [],
      filteredBriefs: [],
      hasSubItems: 0,
      firstItem: 0,
      oldValues: {
        brands: [],
        boards: [],
        formats: [],
        platforms: [],
        languages: [],
        tags: [],
        status: [],
        niches: []
      }
    }
  },
  computed: {
    ...mapGetters('MiscModule', ['getTheme']),
    hasIconSlot () {
      return !!this.$slots.icon
    }
  },
  watch: {
    externalFilters (val, oldVal) {
      if (val[0].selectedFormats === oldVal[0].selectedFormats) return

      console.log('fiilter base select', val[0].selectedFormats)
      this.clearFilters()
      this.handleChecked(val[0]?.selectedFormats?.id)
    },
    clearAll (val) {
      if (val) {
        this.clearFilters()
        this.$emit('update:clearAll', false)
      }
    },
    popperOpen (newVal, oldVal) {
      if (newVal === oldVal) return

      this.items.find((item, index) => {
        if (item.subItems?.length) {
          this.firstItem = index
          return true
        }
      })
      this.items.length && this.handleSelectMainItem(this.firstItem)
    },
    currentSearch (val, oldVal) {
      if (val === oldVal) return

      if (val === '') {
        this.selectedAll = false
      }
    },
    checkedItems (newVal, oldVal) {
      if (newVal.length === oldVal.length) return

      console.log('checkedItems', this.checkedItems)
      if (!this.checkedItems.length) {
        this.briefs && this.$emit('update:filtered', this.briefs)
        return
      }
      this.items.forEach(item => {
        if (this.appliedFilters.includes(item.item)) {
          this.appliedFilters.splice(this.appliedFilters.indexOf(item.item), 1)
        }
        this.getSpecificFilter(item.item).length && this.appliedFilters.push(item.item)
      })

      this.filterBriefs()
      this.briefs && this.$emit('update:filtered', this.filteredBriefs)
      this.$emit('updateCheckedItems', this.checkedItems)
    }
  },
  methods: {
    toggleDrawer () {
      // Make sure not to close on initial click
      if (this.isMouseInside) return
      this.popperOpen = !this.popperOpen
      if (!this.$refs.popper.showPopper) return

      if (this.$refs.popper.showPopper) {
        setTimeout(() => {
          this.$refs.popper.doClose()
        }, 7)
      }
    },
    getClassNames (className) {
      const classNames = [
        'mt-2',
        'popper',
        'overflow-hidden',
        'dropdown-card'
      ]
      let hasSubItems = 0
      this.items.forEach(item => {
        if (item.subItems?.length) {
          hasSubItems++
        }
      })
      this.hasSubItems = hasSubItems
      if (hasSubItems === 1) {
        classNames.push('h-64')
      }
      if (this.whiteBackgroud) {
        classNames.push('dropdown-white', 'filter', 'backdrop-blur-lg')
      }
      if (this.hasSubItems === 8) {
        classNames.push('custom-height')
      }
      if (this.hasSubItems > 5) {
        classNames.push('custom-height')
      }

      if (className && hasSubItems === 8) {
        classNames.push(className)
      }

      if (className && hasSubItems === 5) {
        classNames.push('h-20')
      }
      return classNames.join(' ')
    },
    handleSelectMainItem (index) {
      this.currentSearch = ''
      this.selectedTab = index
    },
    handleOutsideClick () {
      this.popperOpen = true
      this.toggleDrawer()
    },
    containsSearch (subItem, search) {
      return subItem.subItem.toLowerCase().includes(search.toLowerCase())
    },
    handleChecked (subItemId) {
      if (this.checkedItems.length > 0 && this.checkedItems.includes(subItemId)) {
        this.deselectAll()
        this.$emit('updateCheckedItems', this.checkedItems)
        return
      }
      this.deselectAll()
      const index = this.checkedItems.indexOf(subItemId)
      if (this.items[this.selectedTab].toggle) {
        this.items[this.selectedTab].subItems.forEach(subItem => {
          const subItemIndex = this.checkedItems.indexOf(subItem.id)
          if (subItemIndex !== -1) {
            this.checkedItems.splice(subItemIndex, 1)
          }
        })
        this.deselectAll()
        this.$emit('updateCheckedItems', this.checkedItems)
      }

      if (index !== -1) {
        this.checkedItems.splice(index, 1)
        !this.briefs.length && this.filterBriefs()
      } else {
        this.checkedItems.push(subItemId)
        this.getSpecificFilter(this.items[0].item)
      }
    },
    selectAll () {
      for (let i = 0; i < this.items[this.selectedTab]?.subItems.length; i++) {
        const subItemId = this.items[this.selectedTab]?.subItems[i].id
        if (this.currentSearch && !this.containsSearch(this.items[this.selectedTab]?.subItems[i], this.currentSearch)) continue
        this.checkedItems.push(subItemId)
      }
      this.selectedAll = true
    },
    deselectAll () {
      for (let i = 0; i < this.items[this.selectedTab]?.subItems?.length; i++) {
        const subItemId = this.items[this.selectedTab]?.subItems[i].id
        const index = this.checkedItems.indexOf(subItemId)
        if (index !== -1) {
          this.checkedItems.splice(index, 1)
        }
      }
      this.selectedAll = false
    },
    getSelectedFilters () {
      const selectedFilters = []
      for (let i = 0; i < this.items?.length; i++) {
        if (this.items[i]?.subItems?.length) {
          for (let j = 0; j < this.items[i]?.subItems?.length; j++) {
            const subItem = this.items[i]?.subItems[j]
            const item = this.items[i].item
            if (this.checkedItems.includes(subItem.id)) {
              selectedFilters.push({ ...subItem, item })
            }
          }
        }
      }
      return selectedFilters
    },
    getSpecificFilter (filterName) {
      const filter = this.getSelectedFilters().filter((filter) => filter.item === filterName)
      return filter
    },
    clearFilters () {
      this.checkedItems = []
      this.selectedAll = false
      if (!this.briefs.length) {
        this.$emit('clearSelectedDateRange')

        if (this.items.find((item) => item.item === 'Brand' && item.subItems && item.subItems.length > 0 && this.oldValues.brands.length)) {
          this.oldValues.brands = []
          this.emitFunction({ emitString: 'update:selectedBrands', items: [] })
        }

        if (this.items.find((item) => item.item === 'Board' && item.subItems && item.subItems.length > 0 && this.oldValues.boards.length)) {
          this.oldValues.boards = []
          this.emitFunction({ emitString: 'update:selectedBoards', items: [] })
        }

        if (this.items.find((item) => item.item === 'Tag' && item.subItems && item.subItems.length > 0 && this.oldValues.tags.length)) {
          this.oldValues.tags = []
          this.emitFunction({ emitString: 'update:selectedTags', items: [] })
        }

        if (this.items.find((item) => item.item === 'Niche' && item.subItems && item.subItems.length > 0 && this.oldValues.niches.length)) {
          this.oldValues.niches = []
          this.emitFunction({ emitString: 'update:selectedNiches', items: [] })
        }

        if (this.items.find((item) => item.item === 'Format' && item.subItems && item.subItems.length > 0 && this.oldValues.formats.length)) {
          this.oldValues.formats = []
          this.emitFunction({ emitString: 'update:selectedFormats', items: [] })
        }

        if (this.items.find((item) => item.item === 'Language' && item.subItems && item.subItems.length > 0 && this.oldValues.languages.length)) {
          this.oldValues.languages = []
          this.emitFunction({ emitString: 'update:selectedLanguages', items: [] })
        }

        if (this.items.find((item) => item.item === 'Platform' && item.subItems && item.subItems.length > 0 && this.oldValues.platforms.length)) {
          this.oldValues.platforms = []
          this.emitFunction({ emitString: 'update:selectedPlatforms', items: [] })
        }

        if (this.items.find((item) => item.item === 'Status' && item.subItems && item.subItems.length > 0 && this.oldValues.status.length)) {
          console.log('clearing status', this.oldValues.status)
          this.oldValues.status = []
          this.emitFunction({ emitString: 'update:liveStatus', items: [] })
        }
        console.log('old values', this.oldValues)
        this.$emit('change')
      }
    },
    filterBriefs () {
      if (this.briefs.length) {
        this.filteredBriefs = []
        const brandProfileIds = this.getSpecificFilter('Brand Profile').map((filter) => filter.id)
        const folders = this.getSpecificFilter('Folder')
        const statusValues = this.getSpecificFilter('Status').map((filter) => filter.subItem)
        const dueDateValues = []
        this.getSpecificFilter('Due Date').forEach((filter) => { dueDateValues.push(...filter.briefIds) })
        this.filteredBriefs = this.briefs && this.briefs.filter((brief) => {
          return this.filterBrief(brief, brandProfileIds, folders, statusValues, dueDateValues)
        })
      } else {
        const selectedBrands = this.getSpecificFilter('Brand').map((filter) => filter.brand)
        const selectedBoards = this.getSpecificFilter('Board').map((filter) => filter.board)
        const selectedTags = this.getSpecificFilter('Tag').map((filter) => filter.tag)
        const selectedNiche = this.getSpecificFilter('Niche').map((filter) => filter.niche)
        const selectedFormat = this.getSpecificFilter('Format').map((filter) => filter.format)
        const selectedPlatform = this.getSpecificFilter('Platform').map((filter) => filter.platform)
        const selectedLanguage = this.getSpecificFilter('Language').map((filter) => filter.language)
        const selectedStatus = this.getSpecificFilter('Status').map((filter) => filter.status)

        if (this.items.find((item) => item.item === 'Brand' && item.subItems && item.subItems.length > 0) && selectedBrands.length !== this.oldValues.brands.length) {
          this.oldValues.brands = selectedBrands
          this.emitFunction({ emitString: 'update:selectedBrands', items: selectedBrands || [] })
          this.$emit('change')
        }

        if (this.items.find((item) => item.item === 'Board' && item.subItems && item.subItems.length > 0) && selectedBoards.length !== this.oldValues.boards.length) {
          this.oldValues.boards = selectedBoards
          this.emitFunction({ emitString: 'update:selectedBoards', items: selectedBoards || [] })
          this.$emit('change')
        }

        if (this.items.find((item) => item.item === 'Tag' && item.subItems && item.subItems.length > 0) && selectedTags.length !== this.oldValues.tags.length) {
          this.oldValues.tags = selectedTags
          this.emitFunction({ emitString: 'update:selectedTags', items: selectedTags || [] })
          this.$emit('change')
        }

        if (this.items.find((item) => item.item === 'Niche' && item.subItems && item.subItems.length > 0) && selectedNiche.length !== this.oldValues.niches.length) {
          this.oldValues.niches = selectedNiche
          this.emitFunction({ emitString: 'update:selectedNiches', items: selectedNiche || [] })
          this.$emit('change')
        }

        if (this.items.find((item) => item.item === 'Format' && item.subItems && item.subItems.length > 0) && selectedFormat.length !== this.oldValues.formats.length) {
          this.oldValues.formats = selectedFormat
          this.emitFunction({ emitString: 'update:selectedFormats', items: selectedFormat || [] })
          this.$emit('change')
        }

        if (this.items.find((item) => item.item === 'Language' && item.subItems && item.subItems.length > 0) && selectedLanguage.length !== this.oldValues.languages.length) {
          this.oldValues.languages = selectedLanguage
          this.emitFunction({ emitString: 'update:selectedLanguages', items: selectedLanguage || [] })
          this.$emit('change')
        }

        if (this.items.find((item) => item.item === 'Platform' && item.subItems && item.subItems.length > 0) && selectedPlatform.length !== this.oldValues.platforms.length) {
          this.oldValues.platforms = selectedPlatform
          this.emitFunction({ emitString: 'update:selectedPlatforms', items: selectedPlatform || [] })
          this.$emit('change')
        }

        if (this.items.find((item) => item.item === 'Status' && item.subItems && item.subItems.length > 0) && selectedStatus[0]?.name + '' !== this.oldValues.status.name + '') {
          this.oldValues.status = selectedStatus
          this.emitFunction({ emitString: 'update:liveStatus', items: selectedStatus || [] })
          this.$emit('change')
          console.log(selectedStatus, this.oldValues.status)
        }
      }
    },
    filterBrief (brief, brandProfileIds, folders, statusValues, dueDateValues) {
      // brief ids from the selected folders / folder
      const briefIds = []
      folders.forEach(({ folderIds }) => {
        folderIds && briefIds.push(...folderIds)
      })

      // briefs return true or false if in the selected arrays
      return ((brandProfileIds.length ? brandProfileIds.includes(brief.brandProfileId) : true) && (briefIds.length ? briefIds.includes(brief.id) : true) && (statusValues.length ? (statusValues.includes(brief.status) || (statusValues.includes('No Status') && !brief.status)) : true) && (dueDateValues.length ? dueDateValues.includes(brief.id) : true))
    }
  }
}
</script>

<style scoped>
.dropdown-card {
  background: rgba(255, 255, 255, 0.8);

  box-shadow: 0px 24px 32px -12px rgba(54, 57, 74, 0.24), 0px 1px 2px rgba(164, 172, 185, 0.16), 0px 0px 0px 1px rgba(18, 55, 105, 0.08);
  backdrop-filter: blur(10px);

  border-radius: 18px;
}

.dropdown-white{
  background: rgba(255, 255, 255, 0.98);

  box-shadow: 0px 24px 32px -12px rgba(54, 57, 74, 0.24), 0px 1px 2px rgba(164, 172, 185, 0.16), 0px 0px 0px 1px rgba(18, 55, 105, 0.08);
  backdrop-filter: blur(10px);

  border-radius: 18px;
}
.popper{
  padding: 0px !important;
  border: 0px !important;
  transform: translate3d( 12px, 35px, 10px) !important;
}

.custom-height{
  height: 340px;
}
</style>
